import { type ReactNode } from 'react';
import type { FlatMatch } from '@/lib/use-in-page-find';

type Props = {
  /** Testo grezzo del segmento. */
  text: string;
  /** Match che ricadono in questo segmento, in ordine di posizione. */
  matches: FlatMatch[];
  /** Indice globale del match attualmente selezionato. */
  currentIndex: number;
  /** Callback ref applicata al `<mark>` corrente (per lo scroll in vista). */
  registerCurrent?: (el: HTMLElement | null) => void;
};

/**
 * Renderizza testo plain con le occorrenze avvolte in `<mark>`. Il match
 * corrente riceve `data-current` (stile distinto) e la ref per lo scroll.
 * Non usa dangerouslySetInnerHTML: costruisce nodi React dal testo grezzo.
 */
export function HighlightedText({ text, matches, currentIndex, registerCurrent }: Props) {
  if (matches.length === 0) return <>{text}</>;

  const nodes: ReactNode[] = [];
  let cursor = 0;

  for (const m of matches) {
    if (m.start > cursor) nodes.push(text.slice(cursor, m.start));
    const isCurrent = m.index === currentIndex;
    nodes.push(
      <mark
        key={m.index}
        data-current={isCurrent ? '' : undefined}
        ref={isCurrent ? registerCurrent : undefined}
      >
        {text.slice(m.start, m.end)}
      </mark>,
    );
    cursor = m.end;
  }
  if (cursor < text.length) nodes.push(text.slice(cursor));

  return <>{nodes}</>;
}
